import Cookies from 'js-cookie'

const TokenKey = 'Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const UserInfoKey = 'UserInfo'

export function getUserInfo() {
  return JSON.parse(window.sessionStorage.getItem(UserInfoKey))
}

export function setUserInfo(userInfo) {
  return window.sessionStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return window.sessionStorage.removeItem(UserInfoKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js